import template from './noteTypeModal.html';
import controller from './noteTypeModalCtrl';
import './style.scss';

export default {
  template,
  controller,
  controllerAs: 'vm',
  bindings: {
    modalInstance: '<',
  },
};
